import React from "react";
import PropTypes from "prop-types";
import { Text, TextInput, Flex, Box, useMantineTheme } from "@mantine/core";
import { useStylesGeneral } from "../utils/mantine/stampTabContent/useStylesGeneral";
import { useStylesButton } from "../utils/mantine/useStylesButton";
import { useStylesLanding } from "../utils/mantine/useStylesLanding";
import CustomButton from "./mantineCustomComponents/CustomButton";

const VerifyUserFound = ({ userData, onUserDataChange, onUserDataSubmit }) => {
  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();

  const { classes: GeneralClasses } = useStylesGeneral();
  const { classes: buttonClasses } = useStylesButton();
  const { classes: landingClasses } = useStylesLanding();

  return (
    <Box id="verify-method-user-found__screen" className={GeneralClasses.wrap}>
      <Box className={GeneralClasses.wrapContent}>
        <Flex
          direction="column"
          gap={theme.flex.gap.large}
          justify={theme.flex.justify.start}
          align={theme.flex.align.center}
          classNames={{
            root: GeneralClasses.wrapContentContainer,
          }}
        >
          <Box className={GeneralClasses.wrapContentContainerPadding}>
            <Text className="user-found-form-title">Search User Activity:</Text>
            <TextInput
              id="user-data"
              placeholder="Enter Persistent ID, User ID or Display Name"
              value={userData}
              classNames={{
                input: GeneralClasses.input,
              }}
              onChange={onUserDataChange}
            />

            <Flex
              align={theme.flex.align.center}
              className={`${landingClasses.pricingBlockButtons} ${landingClasses.supplementaryInformationBlockButtons}`}
            >
              <CustomButton
                text="See User Activity"
                icon="IconChevronRight"
                onClick={() => onUserDataSubmit()}
                componentClasses={`${buttonClasses.buttonBlack} ${landingClasses.pricingBlockButtonsButton} ${GeneralClasses.button}`}
              />
            </Flex>
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};
VerifyUserFound.propTypes = {
  userData: PropTypes.string.isRequired,
  onUserDataChange: PropTypes.func.isRequired,
  onUserDataSubmit: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};
export default VerifyUserFound;
